import apiClient from "../api/apiClient";
import { Testimonial } from "../interfaces/Testimonial";

export const testimonialService = {

    AddClienttestimonial: async (formData: FormData) => {
        return await apiClient.post(
            "/Testimonial/AddClienttestimonial",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );
    },

    UpdateClienttestimonial: async (formData: FormData) => {

    const response =
        await apiClient.put(
            "/Testimonial/UpdateClienttestimonial",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

    return response.data;
},



    GetClientTestimonials: async (): Promise<Testimonial[]> => {

        const response =
            await apiClient.get<
                ApiResponse<Testimonial[]>
            >(
                "/Testimonial/GetClientTestimonials"
            );

        const result =
            response.data;

        console.log("Testimonial Data List:", result.dataList);

        if (!result.isSuccess) {

            throw new Error(
                result.message
            );
        }

        // return result.data || [];
        return result.dataList || [];
    },

DeleteClienttestimonial: async (id: number) => {

  const response = await apiClient.delete(
    `/Testimonial/DeleteClienttestimonial/${id}`
  );

  return response.data;
},



}


export interface ApiResponse<T> {

  isSuccess: boolean;

  message: string;

  data?: T | null;

  dataList?: T | null;
}